(function () {



  $(document).ready(function () {
    $("#parentHorizontalTab").easyResponsiveTabs({
      type: 'accordion', //Types: default, vertical, accordion           
      width: 'auto', //auto or any custom width
      fit: true,   // 100% fits in a container
      closed: false, // Close the panels on start, the options 'accordion' and 'tabs' keep them closed in there respective view types
      activate: function() {},  // Callback function, gets called if tab is switched
      tabidentify: 'tab_identifier_child', // The tab groups identifier *This should be a unique name for each tab group and should not be defined in any styling or css file.
      activetab_bg: '#B5AC5F', // background color for active tabs in this group
      inactive_bg: '#E0D78C', // background color for inactive tabs in this group
      active_border_color: '#9C905C', // border color for active tabs heads in this group
      active_content_border_color: '#9C905C' // border color for active tabs contect in this group so that it matches the tab head border
    });

  })

});

$( function() {
  $(".m-menu-btn").click(function () {
    // $(".nav_menu").toggleClass("menu-open");
    $(this).toggleClass("m-menu-btn-ext");
  });
});

$( function() {
  if($("#tabs").length>0){
    $( "#tabs" ).tabs();
  } 
});

$(document).ready(function(){
  $('.well-loved-list-slider').slick({
    dots: true,
    infinite: false,
    arrows:true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});

$(document).ready(function(){
  $('.plum_bnx_slider').slick({
    dots: true,
    infinite: false,
    arrows:false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  if($(window).width()<641){
    $('.communoty_slider').slick({
      dots: true,
      infinite: false,
      arrows:false,
      speed: 300,
      slidesToShow:1
    });    
  }
  $('.blog_catlist').slick({
    dots: true,
    infinite: true,
    arrows:false,
    speed: 300,
    slidesToShow:1,
    centerMode: true,
    centerPadding:'10%',
  });
  if($(window).width()<991){    
    $('.boxlabslider').slick({
      dots: true,
      infinite: true,
      arrows:false,
      speed: 300,
      slidesToShow:1,
      adaptiveHeight: true
    });
    $('.homebeslider').slick({
      dots: true,
      infinite: true,
      arrows:false,
      speed: 300,
      slidesToShow:1
    });
  }  
  $('.ftr_title').on('click',function(e){
  	e.preventDefault();
    $(this).next('.ftrmenulist').slideToggle();
    $(this).toggleClass('active');
  });
  $('.type_title').on('click',function(e){
  	e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('.type_data').slideToggle();
  });
});

 if ($(window).width() < 768) {
// $('.div_hide_mob').parent().css('display','none');
  }
  
  $('.div_hide_mob').parent().css('margin','0');

$( ".on_tab_1 " ).click(function() {
   $(".other_no_2").css("display","none");
   $(".other_no_3").css("display","none");
   $(".other_no_1").css("display","block");
});
$( ".on_tab_2 " ).click(function() {
  $(".other_no_2").css("display","block");
    $(".other_no_1").css("display","none");
   $(".other_no_3").css("display","none");
});
$( ".on_tab_3 " ).click(function() {
    $(".other_no_3").css("display","block");
    $(".other_no_1").css("display","none");
   $(".other_no_2").css("display","none");
});